import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=72aab872&scoped=true&lang=pug&"
import script from "./ChatHeader.vue?vue&type=script&lang=ts&"
export * from "./ChatHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=72aab872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aab872",
  null
  
)

export default component.exports